import { Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { AbhaServices } from "../../../redux/Services";
import AbhaLinkedFilter from "../AbhaFilter";
import moment from "moment";
import { AbhaLinkedNotify } from "../../../redux/Services/AbhaLinkded";
import { UserId } from "../../../utils/";
const LinkedLog = () => {
  const filename = "ABHA Address Created / Retrieved and Linked Log";
  const [FilteredData, setFilteredData] = useState([]);
  const permission = usePermission("HIP Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useSearchParams();
  const abhaCreatedList = useSelector(
    (state) => state.abhaCreated.AbhaCardsLogs || []
  );

  const totalabhaCreatedList = useSelector(
    (state) => state.abhaCreated.totalAbhaCardsLogs || ""
  );
  // const { mutate: getabhaCreatedList, isLoading } = useMutation((data) => dispatch(AbhaServices.abhaCreatedList(data, user ,limit, offset)));
  // const totalFaq = useSelector(state => state.faq.totalFaq || "");
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({});
  const { mutate: getabhaCreatedList, isLoading } = useMutation((data) =>
    dispatch(AbhaServices.AbhaCardsLogs(data, user, limit, offset, page))
  );

  const { mutate: Notify, isLoading: addLoading } = useMutation((data) =>
    dispatch(AbhaLinkedNotify(data, navigate))
  );
  const [modal1Open, setModal1Open] = useState(false);
  const [raw, setRaw] = useState({});
  const [ModalNotify, setModalNotify] = useState(false);
  const user = {
    UserId: UserId,
  };
  useEffect(() => {
    AbhaServices.AbhaCardsLogs({ ...filter, currentPage, limit }, dispatch);

    return () => {};
  }, [filter, offset, limit, currentPage]);

  useEffect(() => {
    if (abhaCreatedList && abhaCreatedList.length > 0) {
      var data = [];
      abhaCreatedList.forEach((value, index) => {
        var item = {
          sno: value?.sno,
          id: value?.id,
          log_type: value?.log_type,
          requestor: value?.requestor,
          patient_name: value?.patient_name,
          mobile_no: value?.mobile_no,
          heathid_no: value?.heathid_no,
          health_id: value?.health_id,
          facility_id: value?.facility_id,
          facility_name: value?.facility_name,
          createdAt: value?.createdAt,
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [abhaCreatedList]);

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Log Id", key: "id" },
    { label: "Log Type", key: "log_type" },
    { label: "Requester (HIU/HIP)", key: "requestor" },
    { label: "Patient Name", key: "patient_name" },
    { label: "Mobile Number", key: "mobile_no" },
    { label: "ABHA Number", key: "heathid_no" },
    { label: "ABHA Address", key: "health_id" },
    { label: "Facility ID", key: "facility_id" },
    { label: "Facility Name", key: "facility_name" },
    { label: "Created At", key: "createdAt" },
  ];

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * limit + index + 1,
    },
    // {
    //     title: 'Action',
    //     dataIndex: 'action',
    //     key: 'actiion',
    //     className: 'abha-link-action',
    //     render: (value, item, index) => {
    //         return (
    //             <> <Tooltip placement="top" title={"Link & Notify"}>
    //                 <Button className="view-btn" type="primary" onClick={() => { setRaw(item || {}); setModalNotify(true) }}><LinkOutlined /></Button>
    //             </Tooltip>
    //             </>
    //         )
    //     }
    // },
    {
      title: "Log Id",
      dataIndex: "id",
      key: "id",
      className: "table_status_col",
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
      className: "table_status_col",
      name: "type",
      // render: (value, item, index) => {
      //     return (
      //         <span>{"Callback"}</span>
      //     )
      // }
    },
    // {
    //     title: 'Request Id',
    //     dataIndex: 'id',
    //     key: 'id',
    //     className: 'text-capitalize',
    // },

    {
      title: "Requester (HIU/HIP)",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize",
    },

    {
      title: "Patient Name/Patient Id",
      dataIndex: "raw_data",
      key: "raw_data",
      className: "table_status_col patient",
      render: (value, item, index) => {
        return <span>{JSON.parse(item?.raw_data || "{}")?.name}</span>;
      },
    },
    {
      title: "ABHA Number",
      dataIndex: "heathid_no",
      key: "health_id",
      className: "abha-link-date",
    },
    {
      title: "ABHA Address",
      dataIndex: "health_id",
      key: "health_id",
      width: 200,
    },

    /* {
            title: 'URL',
            dataIndex: 'request_url',
            key: 'request_url',
            className: 'table_status_col',

        }, */
    {
      title: "Facility ID",
      dataIndex: "facility_id",
      key: "facility_id",
      render: (value) => value || "-"
    },
    {
      title: "Facility Name",
      dataIndex: "facility_name",
      key: "facility_name",
      render: (value) => value || "-"
    },
    {
      title: "Date Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>;
      },
    },
    {
      title: "Requested Data",
      dataIndex: "action",
      key: "action",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <>
            <Button
              className="view-btn"
              type="primary"
              onClick={() => {
                setRaw(JSON.parse(item?.raw_data || "{}"));
                setModal1Open(true);
              }}
            >
              {" "}
              View
            </Button>
          </>
        );
      },
    },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col span={24}>
          <HeadingBack
            title={"ABHA Number/Retrived and Linked Log"}
            subHeading={`Records ${totalabhaCreatedList || 0}`}
          />
        </Col>
        <Col span={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            headers={headers}
            FilteredData={FilteredData}
            setFilteredData={setFilteredData}
            filename={filename}
            enableFacilityFilter={true}
          />
        </Col>
        {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey={(row) => row?.Id ?? row?.id}
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          bordered
          columns={columns}
          dataSource={
            Array.isArray(abhaCreatedList) && abhaCreatedList?.length > 0
              ? abhaCreatedList
              : []
          }
          pagination={{
            current: currentPage,
            pageSize: limit,
            total: totalabhaCreatedList,
            onChange(current, pageSize) {
              setPage(current);
              setCurrentPage(current);
              setOffset(() => (currentPage - 1) * limit);
            },
            hideOnSinglePage: true,
          }}
        />
      </div>

      <Modal
        style={{
          top: 20,
        }}
        open={modal1Open}
        onOk={() => setModal1Open(false)}
        onCancel={() => {
          setRaw({});
          setModal1Open(false);
        }}
        footer={null}
      >
        <pre>{JSON.stringify(raw, null, 2)}</pre>
      </Modal>
    </div>
  );
};

export default LinkedLog;
